module.exports = __webpack_public_path__ + "img/bankTransfer1.8510f0c2.png";